import { PersonalOfferItem } from '@entities/Loyalty'

import styles from './PersonalOffersSlider.module.scss'

interface PersonalOffersSliderProps {
  offers: PersonalOfferItem[]
  loading?: boolean
}

export function PersonalOffersSlider ({ offers, loading }: PersonalOffersSliderProps) {
  if (loading) {
    return (
      <div className={styles.root}>
        <div className={styles.loading}>Загрузка персональных предложений...</div>
      </div>
    )
  }

  if (!offers || offers.length === 0) {
    return null
  }

  return (
    <div className={styles.root}>
      <div className={styles.slider}>
        {offers.map((offer) => (
          <div key={offer.xid} className={styles.card}>
            {offer.image?.url && (
              <div className={styles.imageContainer}>
                <img src={offer.image.url} alt={offer.name} className={styles.image} />
              </div>
            )}
            <div className={styles.content}>
              <h4 className={styles.title}>{offer.name}</h4>
              <div className={styles.offer}>
                {offer.preferenceValue && (
                  <span className={styles.value}>
                    {offer.preferenceValue}
                    {offer.type === 'percent' && '%'}
                    {offer.type === 'amount' && '₸'}
                  </span>
                )}
              </div>
              {offer.product && (
                <div className={styles.product}>
                  <span className={styles.productName}>{offer.product.name}</span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}